import { ScriptAnchor } from '@agent/core/phone/script-redirection/models/script-anchor';
import { IScriptRedirect } from '@agent/core/phone/script-redirection/models/script-redirection';
import { IScriptRedirectionService } from '@agent/core/phone/script-redirection/script-redirection.service';
import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { NG1_SCRIPT_REDIRECTION } from '@commons/core/core.provider.ajs';

import { EntryPointType, Logger, ProfileService } from '@contact/upgrade';

@Component({
  selector: 'chat-script-redirection-workspace',
  templateUrl: 'chat-script-redirection-workspace.component.html',
  styleUrls: ['./chat-script-redirection-workspace.component.scss'],
})
export class ChatScriptRedirectionWorkspaceComponent implements OnInit, OnDestroy {
  @Input()
  responseId: string;
  availableAnchorsForCsrRelease: ScriptAnchor[] = [];
  scriptRedirect: IScriptRedirect;
  displayAnchorsForCsrRelease: boolean = false;

  constructor(
    private readonly logger: Logger,
    private readonly profileService: ProfileService,
    @Inject(NG1_SCRIPT_REDIRECTION) private readonly scriptRedirectionService: IScriptRedirectionService
  ) {}

  get isScriptRedirecting(): boolean {
    return this.scriptRedirectionService.isRedirectInProgress(this.responseId);
  }

  ngOnInit(): void {
    this.logger.debug('anchor workspace init');
    this.scriptRedirect = this.scriptRedirectionService
      .getScriptRedirect(this.responseId)
      .getOrElseFunc(() => this.scriptRedirectionService.createScriptRedirect(this.responseId));
    this.scriptRedirect.type = this.getCsrReleaseType();

    this.scriptRedirectionService.getScriptAnchors(this.responseId).then(anchors => {
      anchors.forEach(anchor => {
        if (anchor.type === EntryPointType.RELEASE_CSR) {
          this.availableAnchorsForCsrRelease.push(anchor);
        }
      });

      this.profileService
        .hasPermission$('CSR_CHAT_INCOMING::contact:redirect_to_script_anchor_with_csr_release')
        .subscribe(right => (this.displayAnchorsForCsrRelease = right && this.availableAnchorsForCsrRelease.length > 0));
    });
  }

  ngOnDestroy(): void {
    this.logger.debug('anchor workspace destroy');
    this.scriptRedirectionService.removeScriptRedirect(this.responseId);
  }

  updateScriptRedirect(): void {
    this.scriptRedirectionService.updateScriptRedirect(this.responseId, this.scriptRedirect);
  }

  anchorLabel(anchor: ScriptAnchor): string {
    if (!!anchor.alias) {
      return anchor.alias;
    }
    return anchor.name;
  }

  getCsrReleaseType(): EntryPointType {
    return EntryPointType.RELEASE_CSR;
  }
}
